import { useQuery } from 'react-query';

import getProduct from '@/common/api/products/getProduct';
import { ENDPOINT_PRODUCTS } from '@/common/constants';

export const getQueryKey = (path) => [ENDPOINT_PRODUCTS, path];

const useProduct = (path) => useQuery(getQueryKey(path), getProduct);

export default useProduct;
